var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "vDialog" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.shown,
            expression: "shown",
          },
        ],
        staticClass: "vDialogWrapper",
        style: _vm.zIndex,
        on: {
          click: function ($event) {
            return _vm.handleOverlayClicked($event)
          },
        },
      },
      [_c("div", { staticClass: "dialog" })]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }